import { ActionIcon, Button, Modal } from "@mantine/core";
import { Trash } from "tabler-icons-react";
import { useState } from "react";

import {
  BINGO_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS,
  BINGO_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES,
} from "_roles";

import { AccessRights } from "common/admin/auth/AccessRights";
import { Place } from "place/types/place.model";

export function PlaceAdminRow({
  place,
  onEdit,
  onDelete,
  onDuplicate,
}: {
  place: Place;
  onEdit: () => void;
  onDelete: () => void;
  onDuplicate: () => void;
}) {
  const [opened, setOpened] = useState(false);

  const handleCloseModal = () => {
    onDelete();
    setOpened(false);
  };

  return (
    <tr>
      <td
        onClick={onEdit}
        className="cursor-pointer text-[#0000EE] hover:underline"
      >
        {place.name}
      </td>
      <AccessRights
        authorizedOrganizations={
          BINGO_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS
        }
        authorizedRoles={BINGO_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES}
      >
        <td className="max-w-2">{place.owner.L1}</td>
      </AccessRights>
      <td>
        {new Date(Date.parse(place.creationTime)).toLocaleString(undefined, {
          dateStyle: "short",
          timeStyle: "short",
        })}
      </td>
      <td>
        <div className="flex gap-2">
          {/*gap added*/}
          <ActionIcon onClick={onDuplicate}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icon-tabler-copy"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
              <path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" />
            </svg>
          </ActionIcon>
          <ActionIcon onClick={() => setOpened(true)}>
            <Trash color="red" size={20} />
          </ActionIcon>
          {/* edit button removed */}
        </div>
        <td>
          <Modal
            opened={opened}
            onClose={() => setOpened(false)}
            centered
            radius={0}
            overflow="inside"
            withCloseButton={false}
          >
            <p className="text-xl">Are you sure to delete this place?</p>
            <div className="flex gap-40 mt-6">
              <Button
                style={{ backgroundColor: "#e30613", color: "white" }}
                onClick={handleCloseModal}
                className="w-24"
              >
                Yes
              </Button>
              <Button
                style={{ color: "white" }}
                onClick={() => setOpened(false)}
                className="w-24 bg-button-admin"
              >
                No
              </Button>
            </div>
          </Modal>
        </td>
      </td>
    </tr>
  );
}
